import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { TrustContent } from "@/components/site/TrustContent";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/confianza")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Confianza, Delivery y Procurement: Shugert",
    description: "Cómo Shugert define proyectos Shopify, gestiona accesos, controla releases, valida resultados, documenta límites y facilita procurement.",
    path: "/es/confianza",
    altPath: alternatePath("/es/confianza", "en"),
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Confianza y procurement", path: "/es/confianza" }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <TrustContent locale="es" />
    </SiteShell>
  ),
});
